module.exports = __webpack_public_path__ + "img/bg-green-1.07fa61f8.png";